import { CalendarState, DoctorMapping } from "../api/models";
import {
  Badge,
  Button,
  DialogBottomPanel,
  DialogContent,
  DialogProps,
  LoadingRegion,
  Text,
  makeDialogOpener,
  toast,
  useDataLoader,
  useDialogSize,
  usePendingOperation,
} from "@optimed/react";
import { docplannerService } from "../api";

interface ScheduleSettingsDialogProps extends DialogProps<ScheduleSettingsDialogResult> {
  doctor: DoctorMapping;
}

interface ScheduleSettingsDialogResult {}

export function ScheduleSettingsDialog(props: ScheduleSettingsDialogProps) {
  const { dialog, doctor } = props;
  const [state, statePromise, stateRefresh] = useDataLoader(
    () =>
      docplannerService.calendarState({
        facilityId: doctor.docplanner?.facility?.id,
        doctorId: doctor.docplanner?.doctor?.id,
        addressId: doctor.docplanner?.address?.id,
      }),
    [props.doctor]
  );
  const changePromise = usePendingOperation();
  useDialogSize("400px", "300px");

  const onAccept = () => {
    dialog.close({});
  };

  function changeState(target: boolean) {
    let p = docplannerService
      .calendarState({
        facilityId: doctor.docplanner?.facility?.id,
        doctorId: doctor.docplanner?.doctor?.id,
        addressId: doctor.docplanner?.address?.id,
        set: target,
      })
      .then(() => stateRefresh(false))
      .catch(() => toast.error("Błąd zmiany stanu kalendarza"));
    changePromise.handle(p);
  }

  return (
    <DialogContent header="Ustawienia grafiku">
      <LoadingRegion promise={Promise.all([statePromise, changePromise.promise])}>
        <span>Stan kalendarza: </span>
        {state?.state === CalendarState.Enabled && <Badge type="success">Włączony</Badge>}
        {state?.state === CalendarState.Disabled && <Badge type="warning">Wyłączony</Badge>}
        {state?.state === CalendarState.Unknown && (
          <>
            <Badge type="danger">Nieokreślony</Badge>
            <Text block small>
              <span>Nie można pobrać stanu kalendarza z serwisu Docplanner. Możliwe przyczyny:</span>
              <ul>
                <li>Błąd komunikacji - sprawdź szczegółowe logi usługi</li>
                <li>Kalendarz nie jest trybie zintegrowanym - skontaktuj się z supportem serwisu Docplanner</li>
              </ul>
            </Text>
          </>
        )}
      </LoadingRegion>
      <DialogBottomPanel>
        {state?.state === CalendarState.Enabled && (
          <Button
            text="Wyłącz"
            icon="power-off"
            disabled={changePromise?.state.pending}
            onClick={() => changeState(false)}
          />
        )}
        {state?.state === CalendarState.Disabled && (
          <Button
            text="Włącz"
            icon="calendar-days"
            disabled={changePromise?.state.pending}
            onClick={() => changeState(true)}
          />
        )}
        <Button text="Zamknij" onClick={onAccept} />
      </DialogBottomPanel>
    </DialogContent>
  );
}

export const scheduleSettingsDialog = makeDialogOpener(ScheduleSettingsDialog);
